// Entry point for the build script in your package.json

import "trix"
import "@rails/actiontext"
import "@hotwired/turbo-rails"
import { Application } from "@hotwired/stimulus"

window.Stimulus = Application.start()
window.Stimulus.debug = true

import FloatingDecorationsController from "./controllers/floating_decorations_controller"
import CategoryTreeController from "./controllers/category_tree_controller"
import CartController from "./controllers/cart_controller"
import CartToggleController from "./controllers/cart_toggle_controller"
import ArrayOptionsController from "./controllers/array_options_controller"
import IVDModalController from "./controllers/ivd_modal_controller"
import MobileMenuController from "./controllers/mobile_menu_controller"
import CloudflareTurnstileController from "./controllers/cloudflare_turnstile_controller"

window.Stimulus.register("floating-decorations", FloatingDecorationsController)
window.Stimulus.register("category-tree", CategoryTreeController)
window.Stimulus.register("cart", CartController)
window.Stimulus.register("cart-toggle", CartToggleController)
window.Stimulus.register("array-options", ArrayOptionsController)
window.Stimulus.register("ivd-modal", IVDModalController)
window.Stimulus.register("mobile-menu", MobileMenuController)
window.Stimulus.register("cloudflare-turnstile", CloudflareTurnstileController)
